<template>
  <div>
    <QS-h4-title title="相关应付信息" />
    <el-form label-width="140px">
      <column-box
        :source="source"
        :list="list"
        :column="3"
        :label-width="130"
      >
      </column-box>
    </el-form>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'

export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    source: {
      handler(val) {
        this.source.payStateName = selectOption.paymentStatusDict[val.payState]
        this.source.payTypeName = this.formatEnumeration(this.freeTypeList)[val.payType]
      },
      deep: true,
    },
  },
  data() {
    return {
      list: [
        {
          key: 'id',
          name: '应付ID',
        },
        {
          key: 'payStateName',
          name: '付款状态',
        },
        {
          key: 'payTypeName',
          name: '付款内容',
        },
        {
          key: 'gmtCreate',
          name: '创建时间',
        },
        {
          key: 'completeTime',
          name: '完成时间',
        },
        {
          key: 'closeTime',
          name: '关闭时间',
        },
        {
          key: 'payAmount',
          name: '应付金额',
        },
        {
          key: 'paidAmount',
          name: '已付金额',
        },
        {
          key: 'payDate',
          name: '应付日期',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    this.source.payStateName = selectOption.paymentStatusDict[this.source.payState]
    this.source.payTypeName = this.formatEnumeration(this.freeTypeList)[this.source.payType]
  },
}
</script>

<style>

</style>
